import React from 'react';

const OrderSummary = ({ subtotal, selectedAddress, openOfferPopup, isProcessing }) => {
  return (
    <div className="p-4">
      <div className="flex justify-between mb-2">
        <span className="text-gray-600">Subtotal</span>
        <span className="font-medium">₹{subtotal.toFixed(2)}</span>
      </div>
     
      <div className="flex justify-between text-lg font-bold mt-3 pt-3 border-t">
        <span>Total</span>
        <span>₹{subtotal.toFixed(2)}</span>
      </div>

      <button
        onClick={openOfferPopup}
        disabled={isProcessing}
        className={`w-full mt-4 py-3 rounded-lg font-medium ${
          selectedAddress
            ? 'bg-purple-600 hover:bg-purple-700 text-white'
            : 'bg-yellow-500 hover:bg-yellow-600 text-white'
        } transition-colors`}
      >
        {isProcessing ? 'Processing...' : 'Proceed to Checkout'}
      </button>

      <p className="mt-2 text-xs text-gray-500 text-center">
        Apply coupons & offers in the next step.
      </p>
    </div>
  );
};

export default OrderSummary;
